import { render, staticRenderFns } from "./ModalNavItem.vue?vue&type=template&id=342c4b7d&scoped=true&"
import script from "./ModalNavItem.vue?vue&type=script&lang=js&"
export * from "./ModalNavItem.vue?vue&type=script&lang=js&"
import style0 from "./ModalNavItem.vue?vue&type=style&index=0&id=342c4b7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342c4b7d",
  null
  
)

export default component.exports